import React, { useState, useEffect } from 'react';
import { getGitMetricsFromDB } from '../../../../services/apiServices';
import CommitShareChart from './CommitShareChart';
import PRShareChart from './PRShareChart';
import SearchForm from '../../../common/SearchForm';
import { Col, Container, Modal, Row, Spinner } from 'react-bootstrap';

const CommitPRShareChart = () => {
    const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0];
    const currDay = new Date().toISOString().split('T')[0];

    const [startDate, setStartDate] = useState(firstDay);
    const [endDate, setEndDate] = useState(currDay);
    const [showModal, setShowModal] = useState(false);
    const [gitMetricsData, setGitMetricsData] = useState([]);
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        const getGitMetricsData = async () => {
            let gitMetrics = await getGitMetricsFromDB({
                platform: formData.platform,
                selectedRepositoryId: formData.selectedRepositoryId,
                selectedDeveloperNames: formData.selectedDeveloperNames,
                startDate: formData.startDate,
                endDate: formData.endDate
            });
            setGitMetricsData(gitMetrics.commitsByDevelopers)
        }
        if (formData && (formData?.selectedDeveloperNames.length > 0) && (formData.selectedRepositoryId.length > 0)) {
            getGitMetricsData();
        }
        setShowModal(false);
    }, [formData]);

    const handleCloseModal = () => {
        setShowModal(false);
    }

    return (
        <>
            <Container fluid>
                <SearchForm
                    setFormData={setFormData}
                    setShowModal={setShowModal}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <Row style={{ paddingTop: 8 }}>
                    <Col style={{ paddingRight: 6 }}>
                        <CommitShareChart
                            data={gitMetricsData}
                        />
                    </Col>
                    <Col style={{ paddingLeft: 6 }}>
                        <PRShareChart
                            data={gitMetricsData}
                        />
                    </Col>
                </Row>
            </Container>
            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Body className='modal-body-wrapper'><Spinner animation="border" variant="warning" /></Modal.Body>
            </Modal>
        </>
    );
};

export default CommitPRShareChart;